// extracted by mini-css-extract-plugin
module.exports = {"dragDropDivNotDragging":"DragAndDrop_dragDropDivNotDragging__1u_0p","dragDropDivOnDrag":"DragAndDrop_dragDropDivOnDrag__2ihpe"};